// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OrderOfferTemplate from 'components/order/OrderOfferTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrdersActions } from '../../store/actionCreators';

type Props = {
  order: any,
  user: any,
  logged: boolean,
};

class OrderOfferTemplateContainer extends Component<Props> {
  initialize = async () => {
    try {
      const { orderId } = this.props.match.params;
      const { location, history } = this.props;
      
      // URL 쿼리 파라미터에서 토큰 가져오기
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');
      
      // 토큰이 있으면 쿼리 파라미터로 전달
      if (token) {
        await OrdersActions.getOrder(orderId, { token });
      } else {
        await OrdersActions.getOrder(orderId);
      }
      setTimeout(() => {
        window.print();
        history.goBack();
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    if (this.props.loading === undefined || this.props.loading)
      return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <OrderOfferTemplate
        order={this.props.order}
        user={this.props.user}
        logged={this.props.logged}
      />
    );
  }
}

export default connect(
  ({ orders, user, pender }: State) => ({
    order: orders && orders.order,
    user: user.user,
    logged: !!user.user,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(OrderOfferTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/order/OrderOfferTemplateContainer.js